import React, { Fragment, useEffect, useRef, useState } from 'react';
import { motion, useInView } from 'framer-motion';
const spine = ['VISITANTE', 'WEB', 'WHATSAPP', 'IA', 'CALIFICACIÓN', 'CRM', 'AGENDA', 'SEGUIMIENTO', 'REACTIVACIÓN'];
const satellites = ['VOICE', 'FORMULARIOS', 'APIs', 'OTROS CANALES'];
export function OriginSystem() {
  const containerRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(containerRef, {
    amount: 0.4
  });
  const [activeIndex, setActiveIndex] = useState(0);
  useEffect(() => {
    if (!isInView) return;
    const prefersReduced = typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;
    const interval = setInterval(() => {
      setActiveIndex(i => (i + 1) % spine.length);
    }, 900);
    return () => clearInterval(interval);
  }, [isInView]);
  return <section id="arquitectura" className="bg-carbon py-[72px] md:py-[120px]" data-id="element-120" data-mp="24ar3ii9mujcx">
      <div className="max-w-[1100px] mx-auto px-6 md:px-20" ref={containerRef} data-id="element-121" data-mp="24ctr6vnbc0eh">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-14 md:mb-16 text-center max-w-[640px] mx-auto" data-id="element-122" data-mp="8zfvt4fhhy4r">
          <h2 className="font-display text-[30px] md:text-[44px] font-bold text-arena leading-[1.15]" data-id="element-123" data-mp="3hhca4ph7m713">
            No construimos herramientas aisladas.
            <br data-id="element-124" data-mp="1x3rg3fajjd" />
            Construimos sistemas.
          </h2>
        </motion.div>

        {/* Main spine */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay: 0.1
      }} className="flex flex-wrap items-center justify-center gap-2 md:gap-2.5 mb-10" data-id="element-125" data-mp="3rd6x1wsguo9o">
          {spine.map((step, idx) => {
          const isActive = idx === activeIndex;
          return <Fragment key={step} data-id="element-126" data-mp="5zz32gdg9lpc" data-mpi={idx}>
                <span className={`font-body text-[12px] md:text-[13px] font-medium border rounded-full px-3.5 py-2 transition-all duration-300 ${isActive ? 'bg-verde text-arena border-verde scale-[1.05]' : 'bg-arena/10 text-arena border-arena/10'}`} data-id="element-127" data-mp="35g5kwh6fs5h1">
                  {step}
                </span>
                {idx < spine.length - 1 && <span className={`text-[13px] transition-colors duration-300 ${idx === activeIndex ? 'text-azul' : 'text-arena/25'}`} data-id="element-128" data-mp="tsfnuyoknrsc">
                    →
                  </span>}
              </Fragment>;
        })}
        </motion.div>

        {/* Satellites */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        delay: 0.3
      }} className="flex flex-wrap items-center justify-center gap-2 mb-12" data-id="element-129" data-mp="29hdw1jyb99jr">
          {satellites.map(item => <span key={item} className="font-body text-[11px] uppercase tracking-[0.08em] text-salvia border border-salvia/25 rounded-full px-3 py-1.5" data-id="element-130" data-mp="1qjkuakzfb5ny">
              {item}
            </span>)}
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.4
      }} className="text-center font-body text-[15px] text-arena/55 max-w-[420px] mx-auto" data-id="element-131" data-mp="3fx7toc7ftr1m">
          Cada pieza tiene una función. ORIGEN se encarga de conectarlas.
        </motion.p>
      </div>
    </section>;
}